import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import commonRu from './locales/ru/common.json';
import commonEn from './locales/en/common.json';
import homepageRu from './locales/ru/homepage.json';
import homepageEn from './locales/en/homepage.json';
import navbarRu from './locales/ru/navbar.json';
import navbarEn from './locales/en/navbar.json';
import passRu from './locales/ru/pass.json';
import passEn from './locales/en/pass.json';
import authRu from './locales/ru/authorization.json';
import authEn from './locales/en/authorization.json';
import pricingRu from './locales/ru/pricing.json';
import pricingEn from './locales/en/pricing.json';


const common = {
    ru: commonRu,
    en: commonEn,
};

const homepage = {
    ru: homepageRu,
    en: homepageEn,
};

const navbar = {
    ru: navbarRu,
    en: navbarEn,
};

const pass = {
    ru: passRu,
    en: passEn,
};
const auth = {
    ru: authRu,
    en: authEn,
};
const pricing = {
    ru: pricingRu,
    en: pricingEn,
};


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        detection: {
            order: ['queryString', 'cookie'],
            cache: ['cookie']
        },
        interpolation: {
            escapeValue: false
        },
        ns: ['common', 'homepage', 'navbar', 'pass', 'auth', 'pricing'],
        resources: {
            ru: {
                common: common.ru,
                homepage: homepage.ru,
                navbar: navbar.ru,
                pass: pass.ru,
                auth: auth.ru,
                pricing: pricing.ru,
            },
            en: {
                common: common.en,
                homepage: homepage.en,
                navbar: navbar.en,
                pass: pass.en,
                auth: auth.en,
                pricing: pricing.en,
            }
        },
        defaultNS: 'common',
        lng: 'en',
        fallbackLng: 'en',
    })

export default i18n;